document.addEventListener('DOMContentLoaded', function() {
    initializeReviewsCarousels();

    function initializeReviewsCarousels() {
        const carousels = document.querySelectorAll('.manitoba-reviews-carousel .swiper');
        
        carousels.forEach(function(carousel) {
            const slides = carousel.querySelectorAll('.swiper-slide');
            
            if (slides.length < 2) {
                return;
            }
            
            const autoplayDelay = carousel.parentElement.dataset.autoplayDelay || 5000;
            
            const swiperConfig = {
                slidesPerView: 3,
                spaceBetween: 20,
                grabCursor: true,
                autoHeight: false,
                autoplay: {
                    delay: autoplayDelay,
                    disableOnInteraction: true
                },
                breakpoints: {
                    320: {
                        slidesPerView: 1,
                        spaceBetween: 10
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 15
                    },
                    1024: {
                        slidesPerView: 3,
                        spaceBetween: 20
                    }
                }
            };

            // Récupérer l'ID du conteneur parent
            const carouselContainer = carousel.closest('.manitoba-reviews-carousel');
            const carouselId = carouselContainer ? carouselContainer.id : null;
            
            // Ajouter la pagination si l'élément existe
            const paginationEl = carousel.querySelector('.swiper-pagination');
            if (paginationEl) {
                swiperConfig.pagination = {
                    el: paginationEl,
                    clickable: true,
                };
            }
            
            // Sélectionner les boutons de navigation avec l'ID du conteneur
            const nextEl = carouselId ? document.querySelector(`[data-nav-next="${carouselId}"]`) : null;
            const prevEl = carouselId ? document.querySelector(`[data-nav-prev="${carouselId}"]`) : null;
            if (nextEl && prevEl) {
                swiperConfig.navigation = {
                    nextEl: nextEl,
                    prevEl: prevEl,
                };
            }

            new Swiper(carousel, swiperConfig);
        });
    }
});